import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import ForumFilters from "../../../components/Forums/ForumFilters";
import CustomTabs from "../../../components/Common/CustomTabs";
import ForumCard from "../../../components/Forums/ForumCard";
import CreateForumModal from "../../../components/Modals/CreateForumModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllForums } from "../../../redux/dispatchers/forum.dispatcher";

const tabsData = [
  { id: 1, name: "Popular" },
  { id: 2, name: "Recent discussions" },
];

const Forum = () => {
  const dispatch = useDispatch();

  const { allForums } = useSelector((state) => state.forums);

  const [tabState, setTabState] = useState("Popular");

  const [forumModal, setForumModal] = useState(false);

  const [date, setDate] = useState(null);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  useEffect(() => {
    dispatch(getAllForums());
  }, []);

  return (
    <Layout
      heading="Forum"
      hideSideBar={forumModal}
      onCreate={() => setForumModal(true)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Forum Created Successfully"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, md: 5 }}>
            <ForumFilters />
          </Grid>
          <Grid item size={{ xs: 12, md: 7 }}>
            <CustomTabs
              data={tabsData}
              setTabState={setTabState}
              tabState={tabState}
              onClick={() => {}}
            />
            {allForums?.map((forum) => (
              <ForumCard item={forum} key={forum?.id} />
            ))}
          </Grid>
        </Grid>
      </Box>

      <CreateForumModal
        open={forumModal}
        onClose={() => setForumModal(false)}
        setLoading={setLoading}
        setErrorState={setErrorState}
        setSuccess={setSuccess}
      />
    </Layout>
  );
};

export default Forum;
